module.exports = __webpack_public_path__ + "static/media/FI.1b298415.svg";